/*
 * rheincool — 6-Grad-Temperatur-Modul (6-Grad-Regel-Handoff, TempRuleSlider)
 * Logik [PLATZHALTER — fachlich validieren]:
 *   empfohlen = [außen − empfMinOffset, außen − empfMaxOffset]
 *   grenze    = [außen − grenzMinOffset, außen − grenzMaxOffset]
 *   zu kalt   <  außen − zuKaltOffset
 * Kein CTA, kein Sticky, kein Store — reines Trust-Modul.
 * Die sichtbare Textzeile ist zugleich die aria-live-Region (data-calc-live).
 */
class RcTempRuleSlider extends window.RcCalculator {
  init() {
    this.trackPrefix = 'temp_slider';
    this.aussenOut = this.querySelector('[data-tr-aussen-out]');
    this.pill = this.querySelector('[data-tr-pill]');
    this.scale = this.querySelector('[data-tr-scale]');

    /* Skala sofort mit dem Startwert befüllen — ohne Tracking/Store */
    const initial = this.compute();
    if (initial) this.renderResult(initial);
  }

  trackParams() {
    return { aussentemp: this.fieldValue('aussen') };
  }

  fill(template, params) {
    return Object.entries(params).reduce(
      (text, [key, value]) => text.replaceAll(`{${key}}`, value),
      template || ''
    );
  }

  compute() {
    const aussen = this.fieldValue('aussen');
    if (!Number.isFinite(aussen)) return null;
    const cfg = this.config;
    return {
      aussen,
      empfMin: aussen - (cfg.empfMinOffset ?? 6),
      empfMax: aussen - (cfg.empfMaxOffset ?? 4),
      grenzMin: aussen - (cfg.grenzMinOffset ?? 9),
      grenzMax: aussen - (cfg.grenzMaxOffset ?? 7),
      zuKalt: aussen - (cfg.zuKaltOffset ?? 10),
    };
  }

  setRange(name, text) {
    const el = this.querySelector(`[data-tr-range="${name}"]`);
    if (el) el.textContent = text;
  }

  renderResult(result) {
    const i18n = this.config.i18n || {};
    const grad = (value) => this.formatNumber(value);

    if (this.aussenOut) {
      this.aussenOut.textContent = this.fill(i18n.aussenOut, { aussen: grad(result.aussen) });
    }

    this.setRange('cold', this.fill(i18n.rangeCold, { max: grad(result.zuKalt) }));
    this.setRange('border', this.fill(i18n.rangeBetween, { min: grad(result.grenzMin), max: grad(result.grenzMax) }));
    this.setRange('ok', this.fill(i18n.rangeBetween, { min: grad(result.empfMin), max: grad(result.empfMax) }));
    this.setRange('above', this.fill(i18n.rangeAbove, { min: grad(result.empfMax) }));

    if (this.pill) {
      this.pill.textContent = this.fill(i18n.pill, {
        min: grad(result.empfMin),
        max: grad(result.empfMax),
      });
    }

    if (this.scale) {
      this.scale.setAttribute(
        'aria-label',
        this.fill(i18n.scaleLabel, {
          aussen: grad(result.aussen),
          min: grad(result.empfMin),
          max: grad(result.empfMax),
          gmin: grad(result.grenzMin),
          gmax: grad(result.grenzMax),
          kalt: grad(result.zuKalt),
        })
      );
    }

    /* Sichtbare Zeile = Live-Region ("Bei 32 °C außen: 26–28 °C empfohlen") */
    this.announce(
      this.fill(i18n.line, {
        aussen: grad(result.aussen),
        min: grad(result.empfMin),
        max: grad(result.empfMax),
      })
    );
  }
}

if (!customElements.get('rc-temp-rule-slider')) {
  customElements.define('rc-temp-rule-slider', RcTempRuleSlider);
}
